import React from 'react'
import { Flex, Text } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'

import TutorLanguages from 'src/ui/TutorInfoCards/DetailedTutorInfoCard/subcomponents/TutorLanguages/TutorLanguages'
import { LanguageIconsWithTextType, Language } from '../../types/index'

// maybe the code here should be more simple
const getCommaSeperatedLanguages = (languages: Language[]) => {
  return languages
    .map(({ localizedName }, index) => {
      const addAndString = languages.length > 1 ? t('and ') : ''
      // add comma for first word until second last word (because and replaces comma)
      const commaString =
        languages.length > 1 && index < languages.length - 2 ? ',' : ''
      if (!localizedName) {
        return null
      }
      if (index === languages.length - 1) {
        return addAndString + localizedName
      }
      return localizedName + commaString
    })
    .join(' ')
}

const LanguageIconsWithText: React.FC<LanguageIconsWithTextType> = ({
  languages,
  text = 'Speaks',
}) => {
  let flagText
  if (languages.length === 0) {
    return null
  }
  if (text === 'Speaks') {
    flagText = t(`Speaks %{commaSeperatedLanguages}`, {
      text,
      commaSeperatedLanguages: getCommaSeperatedLanguages(languages),
    })
  } else {
    flagText = t(`Tutors %{commaSeperatedLanguages}`, {
      text,
      commaSeperatedLanguages: getCommaSeperatedLanguages(languages),
    })
  }

  return (
    <Flex
      alignItems="center"
      mb="1x"
      justifyContent={{ _: 'center', tablet: 'flex-start' }}
    >
      <Flex mr="1x" flexShrink={0}>
        <TutorLanguages fluentLanguages={languages} />
      </Flex>
      {/* mb 2px for improved alignment of text and flag icons */}
      <Text fontSize="sm" mb="2px" mt="0,5x">
        {flagText}
      </Text>
    </Flex>
  )
}

export default LanguageIconsWithText
